const PRODUCTION_MARKETING_SITE_URL = "https://vendistri.com";
const DEVELOPMENT_MARKETING_SITE_URL = "http://localhost:5173";

export function resolveMarketingSiteUrl(
  path: string,
  backendUrl = "",
) {
  const isLocalEnvironment = /^(https?:\/\/)?(localhost|127\.0\.0\.1)(:|\/|$)/i
    .test(backendUrl.trim());
  const baseUrl = isLocalEnvironment
    ? DEVELOPMENT_MARKETING_SITE_URL
    : PRODUCTION_MARKETING_SITE_URL;
  const normalizedPath = path.startsWith("/") ? path : `/${path}`;
  return `${baseUrl}${normalizedPath}`;
}

export const marketingSiteUrl = (path: string) =>
  resolveMarketingSiteUrl(path, process.env.REACT_APP_BACKEND_URL);
